import {ApiClient} from "./APIClient";
import {BlogPost} from "../Models/Blog";

const getBlogPosts = (): () => Promise<BlogPost[]> => {
  return async () => await ApiClient.get(`/api/blog`).then(resp => resp.data.Response)
}

export const BlogService = {
  getBlogPosts,
}